module.exports = "<user-verifications-page></user-verifications-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/userVerifications.html
// module id = 1863
// module chunks = 0